import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as styles from './Wrapper.module.scss';

const Wrapper = ({ section, paddingTop, paddingBottom, marginTop, backgroundColour, children, className }) => {
  const classnames = classNames(styles.wrapper, {
    [styles[`background__${backgroundColour}`]]: backgroundColour,
    [styles[`paddingTop__${paddingTop}`]]: paddingTop,
    [styles[`paddingBottom__${paddingBottom}`]]: paddingBottom,
    [styles[`marginTop__${marginTop}`]]: marginTop,
    [className]: className
  });

  const Element = section ? 'section' : 'div';

  return <Element className={classnames}>{children}</Element>;
};

Wrapper.propTypes = {
  section: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['true', 'false'])]),
  paddingTop: PropTypes.oneOf([null, 'xs', 'sm', 'md', 'lg']),
  paddingBottom: PropTypes.oneOf([null, 'xs', 'sm', 'md', 'lg']),
  marginTop: PropTypes.oneOf([null, 'xs', 'sm', 'md', 'lg']),
  backgroundColour: PropTypes.oneOf(['grey', 'neutralNavy', 'sand', 'darkNavy']),
  className: PropTypes.string
};

export default Wrapper;
